export function packageDeliveStoreInitState () {
  return {
    logisticList: [],
    selectedDeliver: '',
    packageList: [],
    step3Data: {},
    logisticsNotPickUpOrders: null,
    packageCountLimit: {
      max: 50,
      min: 1
    },
    communityList: [],
    pkgNextLoading: false,
    packageTypeOptions: [], // 包裹種類
    orderPackageList: [] // 訂單包裹列表
  }
}

export default {
  packageDeliveStoreInitState
}
